import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthToken, LoginCredentials } from '../../types/auth';
import { config } from '../../constants/config';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.authApiUrl,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<AuthToken, LoginCredentials>({
      query: (credentials) => ({
        url: '/connect/token',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          grant_type: 'client_credentials',
          client_id: credentials.clientId,
          client_secret: credentials.clientSecret,
          scope: credentials.scope,
        }),
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;